import { graphql } from "gatsby"
import { useState } from "react"
import NewsletterModal from "../NewsletterSection/NewsletterModal"
import Button from "components/Button"
import Img from "components/Img"
import Paper from "components/Paper"
import { H4 } from "components/Typography"
import { SUPERSET_NEWSLETTER_FORM_ID } from "constants/hubspotFormIds"
import * as css from "./JoinSection.module.css"
import Section from "components/Layout/Section"

function JoinSection({
  leftCtaLink,
  leftCtaText,
  leftText,
  leftLogo,
  centerCtaLink,
  centerCtaText,
  centerText,
  centerLogo,
  centerCtaTracking,
  rightCtaLink,
  rightCtaText,
  rightText,
  rightLogo,
  leftCtaTracking,
  rightCtaTracking,
}) {
  const hasCenter = centerText && centerCtaText
  const [open, setOpen] = useState(false)

  const openModal = () => {
    setOpen(true)
  }

  const closeModal = () => {
    setOpen(false)
  }

  const handleBtnClick = (event) => {
    event.preventDefault()
    openModal()
  }

  return (
    <Section>
      <div
        className={
          hasCenter
            ? "grid grid-cols-1 md:grid-cols-3 gap-6"
            : "grid grid-cols-1 md:grid-cols-2 gap-6"
        }
      >
        <div>
          <Paper className={css.root}>
            {/* Handle both Gatsby processed images and local static paths */}
            {leftLogo?.gatsbyImageData && <Img image={leftLogo} />}
            {leftLogo?.url && !leftLogo.gatsbyImageData && (
              <img
                src={leftLogo.url}
                alt=""
                style={{ height: 48, objectFit: "contain" }}
              />
            )}
            <H4>{leftText}</H4>
            <Button
              rounded
              showBlueBorder
              color="white"
              large
              href={leftCtaLink}
              onClick={leftCtaLink.startsWith("Modal:") ? handleBtnClick : null}
              trackClick={leftCtaTracking}
            >
              {leftCtaText}
            </Button>
          </Paper>
        </div>
        {hasCenter && (
          <div>
            <Paper className={css.root}>
              {centerLogo?.gatsbyImageData && <Img image={centerLogo} />}
              {centerLogo?.url && !centerLogo.gatsbyImageData && (
                <img
                  src={centerLogo.url}
                  alt=""
                  style={{ height: 48, objectFit: "contain" }}
                />
              )}
              <H4>{centerText}</H4>
              <Button
                rounded
                showBlueBorder
                color="white"
                large
                href={centerCtaLink}
                onClick={
                  centerCtaLink?.startsWith("Modal:") ? handleBtnClick : null
                }
                trackClick={centerCtaTracking}
              >
                {centerCtaText}
              </Button>
            </Paper>
          </div>
        )}
        <div>
          <Paper className={css.root}>
            {/* Handle both Gatsby processed images and local static paths */}
            {rightLogo?.gatsbyImageData && <Img image={rightLogo} />}
            {rightLogo?.url && !rightLogo.gatsbyImageData && (
              <img
                src={rightLogo.url}
                alt=""
                style={{ height: 58, objectFit: "contain" }}
              />
            )}
            <H4>{rightText}</H4>
            <Button
              rounded
              showBlueBorder
              color="white"
              large
              href={rightCtaLink}
              onClick={
                rightCtaLink?.startsWith("Modal:") ? handleBtnClick : null
              }
              trackClick={rightCtaTracking}
            >
              {rightCtaText}
            </Button>
          </Paper>
        </div>
      </div>
      {open && (
        <NewsletterModal
          subtitle="Get the latest updates on Superset"
          formId={SUPERSET_NEWSLETTER_FORM_ID}
          trackSubmit="Subscribe today_Superset"
          closeModal={closeModal}
        />
      )}
    </Section>
  )
}

export default JoinSection

export const query = graphql`
  fragment JoinSection on ContentfulJoinSection {
    id
    __typename
    leftCtaLink
    leftCtaText
    leftCtaTracking
    leftText
    leftLogo {
      gatsbyImageData(quality: 100, height: 48, layout: FIXED)
    }
    rightCtaLink
    rightCtaText
    rightCtaTracking
    rightText
    rightLogo {
      gatsbyImageData(quality: 100, height: 58, layout: FIXED)
    }
  }
`
